import * as React from 'react';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import { useState, useEffect } from 'react';
import Theme from '../ui/Theme';

export default function CustomButtonGroup({ buttons, selectedIndex: initialSelectedIndex, handleChange, icon = true }) {
  const [clickedIndex, setClickedIndex] = useState(initialSelectedIndex || 0);

  useEffect(() => {
    if (initialSelectedIndex !== undefined) {
      setClickedIndex(initialSelectedIndex);
    }
  }, [initialSelectedIndex]);

  const getButtonStyle = (index) => ({
    fontFamily: 'Lato',
    fontWeight: 600,
    fontSize: '10px',
    lineHeight: '14px',
    cursor: 'pointer',
    borderRadius: '4px',
    backgroundColor: clickedIndex === index ? Theme.palette.primary.main : '#fff',
    color: clickedIndex === index ? '#fff' : 'inherit',
    '&:hover': {
      backgroundColor: clickedIndex === index ? Theme.palette.primary.main : 'rgba(0, 0, 0, 0.08)',
    },
    margin: '12px 0px',
  });

  return (
    <ButtonGroup variant="outlined" aria-label="Custom button group">
      {buttons.map((button, index) => (
        <Button
          onClick={() => handleChange(index)}
          startIcon={clickedIndex === index && icon ? button.whiteIcon : button.icon}
          sx={getButtonStyle(index)}
        >
          {button.name}
        </Button>
      ))}
    </ButtonGroup>
  );
}
